function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { CONTENT_CLASS, OVERLAY_CLASS } from './Modal.react';
export default (function (_ref) {
  var _global;
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    '@global': (_global = {
      'body.ReactModal__Body--open': {
        '& #app, & #root': {
          filter: 'blur(3px)'
        }
      }
    }, _defineProperty(_global, ".".concat(CONTENT_CLASS), {
      position: 'absolute',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      padding: 0,
      transform: 'translate(-50%, -50%)',
      borderRadius: '3px',
      border: 'none',
      overflow: 'visible',
      backgroundColor: colors.white,
      outline: 'none',
      mediaQueries: {
        'screen and (max-width: 768px)': {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          transform: 'none',
          borderRadius: 0
        }
      }
    }), _defineProperty(_global, ".".concat(OVERLAY_CLASS), {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1001,
      backgroundColor: 'rgba(100, 100, 100, .5)'
    }), _global),
    innerContent: _defineProperty({
      position: 'relative',
      margin: 0,
      padding: '20px',
      maxHeight: '90vh',
      minWidth: '390px',
      overflow: 'auto'
    }, mediaQueries.breakpointTablet, {
      width: '100%',
      minWidth: 0,
      minHeight: '100%'
    }),
    closeButton: _defineProperty({
      position: 'absolute',
      zIndex: 1,
      right: '10px',
      top: '10px',
      width: '25px',
      height: '25px',
      borderRadius: '50px',
      background: colors.grayDark,
      textAlign: 'center',
      lineHeight: '30px',
      cursor: 'pointer',
      color: colors.white
    }, mediaQueries.breakpointTablet, {
      width: '35px',
      height: '35px',
      right: '10px',
      top: '10px',
      paddingTop: '5px'
    }),
    closeIcon: {
      fill: colors.white,
      width: '15px',
      height: '15px'
    }
  };
});